export default __webpack_public_path__ + "static/media/offer-2.b7fa96df.webp";